"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tlv_1 = require("../../../core/tlv");
var TLVConverter = /** @class */ (function () {
    function TLVConverter() {
        this.serializer = new tlv_1.TLV.Serializer();
        this.parser = new tlv_1.TLV.Parser();
    }
    TLVConverter.prototype.encode = function (data) {
        return this.serializer.serialize(data);
    };
    TLVConverter.prototype.decode = function (data) {
        var tlvTree = this.parser.parse(data);
        return tlvTree;
    };
    return TLVConverter;
}());
exports.TLVConverter = TLVConverter;
